module.exports = __webpack_public_path__ + "static/media/theZoneClientSample.f46c38ba.xls";